import { all, takeLatest, call, put } from "redux-saga/effects";
import defaultFetch from "./fetch/defaultFetch";

import { actions } from "react/api/actions/routeDivisionModal";
import { actions as crudActions } from "react/api/actions/crud";

function* routeValidateSaga(action) {
  const data = action.payload;

  yield all([
    put({ type: actions.toggleLoading, payload: true }),
    put({ type: crudActions.clearFormError, payload: { entity: "Route" } }),
  ]);

  const routeValidateResponse = yield call(
    defaultFetch,
    "/Route/Validate",
    data,
    "POST"
  );

  if (routeValidateResponse?.error) {
    const { key, message } =
      routeValidateResponse.error.errorMessages[0].resource;

    yield put({
      type: crudActions.saveFormError,
      payload: { entity: "Route", customError: key, errorMessage: message },
    });
  } else {
    yield put({
      type: actions.routeValidateSuccess,
      payload: { data },
    });
  }
  yield put({
    type: actions.toggleLoading,
    payload: false,
  });
}

function* watchRouteValidate() {
  yield takeLatest(actions.routeValidate, routeValidateSaga);
}

function* closeModalSaga() {
  yield put({
    type: crudActions.clearFormState,
    payload: {
      entity: "Route",
    },
  });
}

function* watchCloseModal() {
  yield takeLatest(actions.closeModal, closeModalSaga);
}

export default function* () {
  yield all([watchRouteValidate(), watchCloseModal()]);
}
